import { formatBDT } from "utils/formatPrice"
import DisplayToggle from "./DisplayToggle"

const PriceDisplay = ({
  askingPrice,
  discountPrice,
  showLastPrice = true,
}) => {
  if (!askingPrice && !discountPrice) {
    return <span className="text-muted">-</span>
  }

  const hasDiscount =
    askingPrice && discountPrice && discountPrice < askingPrice

  // Determine label for asking price
  const askingLabel = hasDiscount ? "Asking Price" : "Last Price"

  return (
    <div className="d-flex flex-column mb-1">
      {/* Price section */}
      <div className="d-flex flex-column">
        <span className="text-muted small fw-medium">{askingLabel}</span>
        <span className="fw-bold text-primary">{formatBDT(askingPrice)}</span>
      </div>

      {/* Discount / Last Price section */}
      {hasDiscount && discountPrice && showLastPrice && (
        <DisplayToggle>
          <div
            className="badge bg-light text-dark fw-semibold shadow-sm rounded p-1 mb-1"
            style={{ minWidth: "90px" }}
          >
            <div
              className="d-flex flex-column text-center"
              style={{ lineHeight: 1.2 }}
            >
              <span className="text-secondary fw-medium">Last Price</span>
              <span className="fw-semibold">{formatBDT(discountPrice)}</span>
              <small className="text-danger fw-medium">
                {Math.round(
                  ((askingPrice - discountPrice) / askingPrice) * 100
                )}
                % Off
              </small>
            </div>
          </div>
        </DisplayToggle>
      )}
    </div>
  )
}

export default PriceDisplay
